import { Add, Dashboard, ExitToApp, LockOpen, People, PersonOutlined } from '@mui/icons-material';
import { Routing } from '@fabiulous/routing/dist/types';

import { Dictionary } from '@shared/dictionary';


export const routes = {
  home: '/',
  welcome: '/welcome',
  auth: {
    path: '/auth',
    routes: {
      impersonateUser: '/impersonate',
      login: '/login',
      resetPasswordConfirm: '/reset-password-confirm',
      resetPassword: '/reset-password',
      signup: '/signup',
    },
  },
  team: '/team',
  tributes: {
    path: '/tributes',
    routes: {
      create: {
        path: '/create',
        routes: {
          details: '/details',
          media: '/media',
          story: '/story',
          preview: '/preview',
          order: (tributeId: string | number = ':tributeId') => `/order/${tributeId}`,
        },
      },
      edit: (tributeId: string | number = ':tributeId') => ({
        path: `/edit/${tributeId}`,
        routes: {
          preview: '/preview',
        },
      }),
      view: (tributeId: string | number = ':tributeId') => `/view/${tributeId}`,
      myTributes: '/my-tributes',
    },
  },
  users: {
    path: '/users',
    routes: {
      create: '/create',
      myAccount: '/my-account',
      edit: (userId: string | number = ':userId') => `/edit/${userId}`,
      invite: (token: string = ':token') => `/invitation/${token}`,
    },
  },
  gift: {
    path: '/gift',
    routes: {
      create: '/create',
      regift: (creditId: string | number = ':creditId') => `/regift/${creditId}`,
    },
  },
  start: '/start',
};

export const navigation = (router: Routing.RecursiveRoutes<typeof routes>, dictionary: Dictionary): CVT.Navigation.Config => ({
  userMenu: [{
    icon: <LockOpen />,
    text: dictionary.menu.auth.login,
    route: router.auth.login.path,
    requiresAuth: false,
  }, {
    icon: <ExitToApp />,
    text: dictionary.menu.auth.signUp,
    route: router.auth.signup.path,
    requiresAuth: false,
  }],
  sidebar: [{
    icon: <Dashboard />,
    text: dictionary.menu.dashboard,
    route: router.home.path,
  }, {
    divider: true,
  }, {
    icon: <People />,
    text: dictionary.menu.users.team,
    route: router.users.path,
    requiresAuth: true,
    permission: 'users.view',
    children: [{
      icon: <Add />,
      text: dictionary.menu.users.create,
      route: router.users.create.path,
      permission: 'users.create',
    }],
  }],
  header: [
    {
      text: dictionary.menu.start,
      route: router.start.path,
    },
    {
      text: dictionary.menu.faq,
      dialogId: 'faq',
    },
    {
      text: dictionary.menu.help,
      dialogId: 'help',
    },
    {
      text: 'LGCYPet.com',
      href: 'https://lgcypet.com/',
    },
    {
      icon: <PersonOutlined />,
      text: dictionary.menu.myTributes,
      route: router.tributes.myTributes.path,
      requiresAuth: true,
      // permission: 'users.view',
    },
  ],
});
